import React, { useContext, useEffect, useState } from 'react'
import { 
    Container,
    FiltersDiv,
    FiltersText
 } from './style'

interface DropdownMenu {
    ref: HTMLDivElement,
    text: string,
    isNumber: boolean,
    onClick: (value: string) => void
}

const FiltersDropdown = React.forwardRef<HTMLDivElement, DropdownMenu>((props, forwardRef) => {
    let filteredFilters = ["Contém", "Não contém", "Começa com", "Acaba com", "É igual a", "É diferente de"]
    if (props.isNumber){
        filteredFilters = ["É igual a", "É diferente de", "É maior que", "É menor que", "É maior/igual que", "É menor/igual que"]
    }
    if (props.text !== ""){
        filteredFilters = filteredFilters.filter(str => str.toLowerCase().includes(props.text.toLowerCase()))
    }

    return (
        <Container ref={forwardRef}>
            {filteredFilters.map(filters => 
                <FiltersDiv key={filters} onClick={() => props.onClick(filters)}>
                    <FiltersText>{filters}</FiltersText>
                </FiltersDiv>              
            )}
        </Container>
    )
})

FiltersDropdown.displayName = "FiltersDropdown";

export default FiltersDropdown